// Register font
import { Font } from '@react-pdf/renderer';

Font.register(
	{
		family: 'Plus Jakarta Sans',
		fonts: [
			{
				src: '/fonts/PlusJakartaSans-Regular.ttf',
			},
			{
				src: '/fonts/PlusJakartaSans-Light.ttf',
				fontWeight: 'light',
			},
			{
				src: '/fonts/PlusJakartaSans-Bold.ttf',
				fontWeight: 'bold',
			},
			{
				src: '/fonts/PlusJakartaSans-LightItalic.ttf',
				fontStyle: 'italic',
				fontWeight: 'light',
			},
		],
	},
);

// disable word hyphenation
Font.registerHyphenationCallback(word => {
	return [word];
});
